// test2970
(2970 && 0);
